module.exports = __webpack_public_path__ + "img/back-page.3d97c6ed.webp";